import { MemberType } from "../common/constants";

export class AccountModel{
    id: number;
    memberType: string;
    memberAccountId : string;
    memberAccountName : string;
    customerAgentId : number;
    memberLevelId : number;
  }


// WEBPACK FOOTER //
// ./src/app/customerservice/models/account-model.ts